import { createContext, useContext, useEffect, useState } from "react";
import { http, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = authed
  const [error, setError] = useState("");

  const refresh = async () => {
    try {
      const r = await http.get("/auth/me");
      setUser(r.data);
      return r.data;
    } catch {
      setUser(false);
      return null;
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (email, password) => {
    setError("");
    try {
      const r = await http.post("/auth/login", { email, password });
      setUser(r.data);
      return true;
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const register = async (email, password, name, hipaa_ack = false, invite_code = "") => {
    setError("");
    try {
      const body = { email, password, name, hipaa_ack };
      if (invite_code && invite_code.trim()) body.invite_code = invite_code.trim().toUpperCase();
      const r = await http.post("/auth/register", body);
      setUser(r.data);
      return true;
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const logout = async () => {
    try {
      await http.post("/auth/logout");
    } finally {
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refresh, error, setError }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
